import React from "react";
import { useLanguage } from "../context/LanguageContext";
import LegalPage from "../components/LegalPage";

const Terms = () => {
  const { t } = useLanguage();
  return <LegalPage data={t.termsPage} />;
};

export default Terms;
